
import { useTranslation } from 'react-i18next';

import { Plus } from 'lucide-react';

import { useModal } from '@app/components/modal-views/context';
import { buttonConstant } from '@app/constants/locales/button';
import { localesCommon } from '@app/constants/locales/common';
import { groupConstant } from '@app/constants/locales/group';
import { handleRegexType } from '@app/models/enums/group-regex';
import { Button } from '@app/shadcn/components/ui/button';
import { useWorkspacePermissions } from '@app/lib/hooks/use-workspace-permissions';
import { WorkspacePermission } from '@app/models/enums/workspace-permission';
import { isEmptyString } from '@app/utils/string-utils';


interface IRegexCardProps {
    handleRegex: (regex: string, type: handleRegexType) => void;
    regex?: string;
}

export default function RegexCard({ handleRegex, regex }: IRegexCardProps) {
    const { t } = useTranslation();
    const { openModal } = useModal();
    const { can } = useWorkspacePermissions();
    const canManageGroups = can(WorkspacePermission.MEMBERS_MANAGE);

    return (
        <div>
            <div className="flex flex-col md:flex-row justify-between items-start  md:items-center">
                <p className="h4-new font-medium!">{t(groupConstant.regex.title)}</p>
            </div>
            <div className="border-y-black-300 border-y py-4 mt-4">
                <div className="flex justify-between">
                    <div>
                        <p className="body4 text-black-700!">{t(groupConstant.regex.description)}</p>
                        <p className="body4 text-black-700!">
                            Eg: johndoe@<span className=" underline underline-offset-[6px]">yourdomain.any</span>
                        </p>
                    </div>
                    {regex?.length === 0 && canManageGroups && (
                        <Button variant="ghost" onClick={() => openModal('ADD_REGEX', { handleRegex: handleRegex })}>
                            <Plus className="h-4 w-4 mr-2" />
                            {t(buttonConstant.addRegex)}
                        </Button>
                    )}
                </div>
                {!!regex && !isEmptyString(regex) && (
                    <>
                        <p className="body1 mt-7 mb-3">{t(localesCommon.added)}</p>
                        <div className="px-2 py-3 border-2 border-black-400  rounded flex items-center justify-between md:w-[400px] body4">
                            <p className="text-black-800! truncate">
                                {regex}
                            </p>
                            {canManageGroups && (
                                <span onClick={() => handleRegex(regex, handleRegexType.REMOVE)} className="text-red-500 cursor-pointer">
                                    {t(localesCommon.remove)}
                                </span>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}